// extracted by mini-css-extract-plugin
export default {"modal":"ofa","heading":"pfa","product":"qfa","note":"rfa","notetitle":"sfa","notetext":"tfa","line":"ufa","plan":"vfa","planimage":"wfa","description":"xfa"};
    if(module.hot) {
      // 1715632479691
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  